import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Filters from "../../../../components/Filter/filters";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { hasGameficandusModule } from "../../../../utils/accessSession";
import RankingModal from "../Show/ranking";
import Statistics from "../Show/statistics";

class ClassroomList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // list: [],
      filtered: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true,
      statisticsID: null,
      statisticsName: null,
      rankingID: null,
      rankingName: null,
      paginationData: {
        bufferingPage: true,
        // prevPageBuffer: [],
        // nextPageBuffer: [],
        nameFilter: null,
        currPage: 1,
        sizePerPage: 10,
        totalItems: 0,
        totalPages: 1,
        fistItemIndex: 1,
        lastItemIndex: 1,
        changeNameFilter: this.changeNameFilter.bind(this),
        changePage: this.changePage.bind(this),
        changeSizePerPage: this.changeSizePerPage.bind(this)
      },
      classFilters: {
        group: null,
        region: null,
        school: null,
        years: [new Date().getFullYear()],
        isMultigrade: null
      }
    };

    this.error = this.error.bind(this);
    this.filterClasses = this.filterClasses.bind(this);
    this.insertRoom = this.insertRoom.bind(this);
    this.importStudents = this.importStudents.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertRoom() {
    this.props.history.push("/classroom/form");
  }

  filterClasses(
    role = null,
    group = null,
    region = null,
    school = null,
    years = [],
    isMultigrade = null
  ) {
    this.setState({ filtered: null }, () => {
      this.setState(
        state => ({
          // filtered: state.list.filter(
          //   room =>
          //     (!group || room.group_id === group) &&
          //     (!region || room.region_id === region) &&
          //     (!school || room.school_id === school)
          // ),
          // filtered: state.list,
          classFilters: {
            ...state.classFilters,
            group,
            region,
            school,
            years,
            isMultigrade
          },
          paginationData: {
            ...state.paginationData,
            currPage: 1
          }
        }),
        () => this.handleRooms()
      );
    });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleRooms();
  }

  handleRequest() {
    switch (this.props.general.active_roles.role_id) {
      case 1:
        // Adm Educandus
        return `${URL.api}community/room/list?class=true`;
      case 2:
        // Adm de grupo
        if (this.props.general.active_roles.school_id) {
          return `${URL.api}community/room/list?class=true&school[]=${this.props.general.active_roles.school_id}`;
        }
        return `${URL.api}community/room/list?class=true&group[]=${this.props.general.active_roles.group_id}`;
      case 3:
        // Adm regional
        return `${URL.api}community/room/list?class=true&region[]=${this.props.general.active_roles.region_id}`;
      case 4:
        // Adm escolar
        return `${URL.api}community/room/list?class=true&school[]=${this.props.general.active_roles.school_id}`;
      default:
        // Demais usuários
        return `${URL.api}community/room/listByUser?class=true&user=${this.props.user.user.id}`;
    }
  }

  handleRooms = () => {
    const requestRoute = this.handleRequest();

    axios
      .get(requestRoute, {
        headers: { Authorization: `Bearer ${this.props.user.token}` },
        params: {
          page: this.state.paginationData.currPage,
          offset: this.state.paginationData.sizePerPage,
          name: this.state.paginationData.nameFilter
            ? this.state.paginationData.nameFilter
            : null,
          group: this.state.classFilters.group
            ? [this.state.classFilters.group]
            : [],
          region: this.state.classFilters.region
            ? [this.state.classFilters.region]
            : [],
          school: this.state.classFilters.school
            ? [this.state.classFilters.school]
            : [],
          yearRange:
            this.state.classFilters.years.length > 0
              ? this.state.classFilters.years
              : [],
          is_multigrade:
            this.state.classFilters.isMultigrade !== null
              ? this.state.classFilters.isMultigrade
              : null
        }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              filtered: null
            }),
            () => {
              if (resp.data.data?.length === 0) {
                this.setState(() => ({
                  filtered: [],
                  loading: false
                }));
              } else {
                this.setState(
                  prevState => ({
                    filtered: resp.data?.data.map(room => ({
                      ...room,
                      series:
                        room.room_disciplines
                          .map(discipline => discipline.serie_name)
                          .filter(
                            (value, index, self) =>
                              self.indexOf(value) === index
                          )
                          .join(", ") || "-",
                      ano: room.start ? room.start.substring(0, 4) : "-"
                    })),
                    loading: false,
                    paginationData: {
                      ...prevState.paginationData,
                      bufferingPage: false,
                      totalItems: resp.data?.meta?.total,
                      totalPages: resp.data?.meta?.last_page,
                      firstItemIndex: resp.data?.meta?.first_item,
                      lastItemIndex: resp.data?.meta?.last_item
                    }
                  })
                  // () => {
                  //   this.filterClasses(
                  //     null,
                  //     this.props.general.active_roles.group_id,
                  //     this.props.general.active_roles.region_id,
                  //     this.props.general.active_roles.school_id
                  //   );
                  //   this.forceUpdate();
                  // }
                );
              }
            }
          );
        },
        error => {
          this.error("Nâo foi possível listar as turmas");
        }
      );
  };

  deleteRooms = rows => {
    const obj = {
      rooms: rows
    };

    axios
      .post(`${URL.api}community/room/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleRooms();
        },
        () => {
          this.error("Não foi possível apagar os usuários");
        }
      );
  };

  handleStatistic = (id, name) => {
    this.setState({ statisticsID: id, statisticsName: name });
  };

  // Ranking da turma — o modal só é montado depois de escolhida a turma, para
  // que ele busque os dados daquela turma no próprio componentDidMount (mesmo
  // padrão do modal de Estatísticas, logo acima).
  openRanking = room => {
    this.setState({ rankingID: room.id, rankingName: room.name });
  };

  changeSizePerPage = newSizePerPage => {
    if (!newSizePerPage || newSizePerPage === 0) return;

    this.setState(
      prevState => ({
        paginationData: {
          ...prevState.paginationData,
          bufferingPage: true,
          currPage: 1,
          sizePerPage:
            newSizePerPage === "Todos"
              ? prevState.paginationData.totalItems
              : Number(newSizePerPage)
        }
      }),
      () => this.handleRooms()
    );
  };

  changePage = newPage => {
    if (newPage < 1 || newPage > this.state.paginationData.totalPages) return;

    this.setState(
      prevState => ({
        paginationData: {
          ...prevState.paginationData,
          bufferingPage: true,
          currPage: newPage
        }
      }),
      () => this.handleRooms()
    );
  };

  changeNameFilter = newNameFilter => {
    this.setState(
      prevState => ({
        paginationData: {
          ...prevState.paginationData,
          bufferingPage: true,
          nameFilter: newNameFilter,
          currPage: 1
        }
      }),
      () => this.handleRooms()
    );
  };

  // NOVO MÉTODO PARA IMPORTAR ALUNOS
  importStudents = room => {
    // Debug para verificar a estrutura da room
    console.log("🔍 ESTRUTURA COMPLETA DA ROOM:", room);
    console.log("🔍 ROOM_DISCIPLINES:", room.room_disciplines);

    // Encontra a série/abreviação
    const firstDiscipline = room.room_disciplines?.[0];
    const serieAbbreviation =
      firstDiscipline?.serie_abbreviation || firstDiscipline?.serie_name || "";

    this.props.history.push({
      pathname: "/importallocate/students",
      state: {
        group_id: room.group_id,
        room_id: room.id,
        serie_abbreviation: serieAbbreviation
      }
    });
  };

  render() {
    const temGameficandus = hasGameficandusModule(this.props.user.user_modules);

    return (
      <>
        {!!this.state.statisticsID && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsID: false })}
            room_id={this.state.statisticsID}
            name={this.state.statisticsName}
          />
        )}

        {!!this.state.rankingID && (
          <RankingModal
            show
            onClose={() => this.setState({ rankingID: null })}
            room_id={this.state.rankingID}
            name={this.state.rankingName}
          />
        )}

        <div className="animated fadeIn">
          {this.state.loading ? (
            <Loading />
          ) : (
            <Row>
              <Breadcrumb current={this.props.currentRoute} />
              <Filters
                key={JSON.stringify(this.props.general.active_roles)}
                initial="group"
                type="hierarchy"
                group
                region
                school
                years
                multigradeToggle
                action={this.filterClasses}
              />
              {this.state.filtered ? (
                <div id="list">
                  <DataTable
                    list={this.state.filtered}
                    path="/classroom/edit/"
                    title="Turmas"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "name", denomination: "Nome" },
                      { name: "series", denomination: "Séries" },
                      // Ano é sempre 4 dígitos: o que sobra de largura aqui
                      // é o que faltava para a coluna de ações.
                      { name: "ano", denomination: "Ano", width: "80" }
                    ]}
                    // Largura reservada para as 6 ações da linha, para que a
                    // última não seja cortada em telas médias. Abaixo de 768px
                    // o responsiveCards assume e a largura deixa de valer.
                    actionWidth="300"
                    responsiveCards
                    insert
                    btnMigrate
                    pathMigrate="/classroom/migrate/"
                    delete
                    handleStatistic={this.handleStatistic}
                    action
                    membersPath="/classroom/members/"
                    btnMembers
                    btnEdit
                    btnStatistics
                    // NOVAS PROPRIEDADES PARA IMPORTAR ALUNOS
                    btnImportStudents
                    importStudentsAction={this.importStudents}
                    btnRanking={temGameficandus}
                    rankingAction={this.openRanking}
                    insertAction={this.insertRoom}
                    deleteAction={ids => this.deleteRooms(ids)}
                    paginationData={this.state.paginationData}
                  />
                </div>
              ) : (
                <Loading />
              )}
            </Row>
          )}
          <ProtectedRoute routeId={this.props.currentRoute} />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomList);
